import { Component, HostListener } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  public loginDetail:any =[];
  private readonly sidebarStateKey = 'sidebar_selection_v2';


  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login');
    this.sideIcon(true);
  }

  close(){
    $('#CONFIRMPopup').modal('toggle');
  }

  redirect(){
    this.router.navigate(['/dashboard']);
  }

  over(status = 1) {
    if (!this.isDesktop() || !this.isCollapsed()) {
      return;
    }

    $('.main-site-wrap').toggleClass('sidebar-hovered', status === 1);
  }

  sideIcon(firstLogin = false) {
    if (!this.isDesktop()) {
      if (firstLogin) {
        $('.main-site-wrap').removeClass('toggled').removeClass('sidebar-hovered');
      } else {
        $('.main-site-wrap').toggleClass('toggled').removeClass('sidebar-hovered');
      }
      return;
    }

    this.setDesktopState(firstLogin ? this.isCollapsed() : !this.isCollapsed());
  }

  private isDesktop(): boolean {
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  private isCollapsed(): boolean {
    // Ignore the legacy key so environments with an old expanded preference
    // start with the intended icon-only desktop navigation.
    return localStorage.getItem(this.sidebarStateKey) !== '0';
  }

  private setDesktopState(collapsed: boolean): void {
    $('.main-site-wrap')
      .toggleClass('toggled', collapsed)
      .removeClass('sidebar-hovered');
    localStorage.setItem(this.sidebarStateKey, collapsed ? '1' : '0');
  }

  closeMobileDrawer(): void {
    if (!window.matchMedia('(max-width: 1024px)').matches) return;

    $('.main-site-wrap').removeClass('toggled').removeClass('sidebar-hovered');
  }

  @HostListener('document:keydown.escape')
  closeDrawerOnEscape(): void {
    this.closeMobileDrawer();
  }
}
